<template>
  <v-container fluid class="flex-column pa-0">
    <!-- ボディ１：でんき切り替えシミュレーション結果、検索条件変更ボタン -->
    <v-row no-gutters class="flex-center h-170-170 spacing-pa-40-24" style="background-color: #E7EAFA; width: 100%;">
      <v-col md="7" cols="12" class="flex-center">
        <span class="font-36-24 nowrap">でんき切替シミュレーション結果</span>
      </v-col>
      <v-col md="5" cols="12" class="flex-center">
        <v-btn class="w-280-230 h-85-68 radius-5 font-18-16" style="box-shadow: none;" @click="goToSearchWithDialog()">
            現在のシミュレーション<br>条件を変更する
            <v-icon right class="blue">mdi-arrow-right-circle</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
  <v-spacer class="spacing-h-56-32"/>
  <v-container fluid class="flex-column pa-0 max-w-1200-350">
    <!-------------------------------------------------- 
        サマリ：あなたが再エネ電力に切り替えた場合のCO2削減量
        (ペットボトル、ガソリン、桜の木)
    -------------------------------------------------->
    <!-- 見出し -->
    <v-row class="flex-center-y">
      <div class="flex-center-y">
        <v-icon class="font-14-12 blue spacing-mr-12-8">mdi-circle</v-icon>
        <div class="font-30-22 text-left">あなたが再エネ電力に切り替えた場合のCO2削減量</div>
      </div>
    </v-row>
    <v-spacer class="spacing-h-40-24"/>
    <!-- サマリ：画像（ペットボトル、ガソリン、桜の木） -->
    <v-row no-gutters :class="smAndDown ? 'flex-center space-between' : 'flex-center space-evenly'">
      <v-col md="3" cols="3">
          <div class="flex-center flex-column h-150-150">
              <div class="font-30-14 blue mb-1">ペットボトル</div>
              <v-img class="w-200-90" :src="require('@/assets/fv/plasticBottle.svg')" />
              <div class="blue">
                  <span class="font-64-18">{{ plasticBottle.toLocaleString() }}</span>
                  <span class="font-30-12">本分</span>
              </div>
          </div>
      </v-col>
      <v-col md="3" cols="3">
          <div class="flex-center flex-column h-150-150">
              <div class="font-30-14 blue mb-1">ガソリン</div>
              <v-img class="w-370-130" :src="require('@/assets/fv/gasolene.svg')" />
              <div class="blue nowrap">
                  <span class="font-64-18">{{ gasolene.toLocaleString() }}</span>
                  <span class="font-30-12">リットル分</span>
              </div>
          </div>
      </v-col>
      <v-col md="3" cols="3">
          <div class="flex-center flex-column h-150-150">
              <div class="font-30-14 blue mb-1">桜の木</div>
              <v-img class="w-200-90" :src="require('@/assets/fv/tree.svg')" />
              <div class="blue">
                  <span class="font-64-18">{{ tree.toLocaleString() }}</span>
                  <span class="font-30-12">本分</span>
              </div>
          </div>
      </v-col>
    </v-row>
    <v-spacer class="spacing-h-100-80"/>
    <!-------------------------------------------------- 
        電力会社一覧
    -------------------------------------------------->
    <!-- 見出し -->
    <v-row class="flex-center-y">
      <div class="flex-center-y">
        <v-icon class="font-14-12 blue spacing-mr-12-8">mdi-circle</v-icon>
        <div class="font-30-22 text-left">再エネ電力プラン一覧</div>
      </div>
    </v-row>
    <v-spacer class="spacing-h-10-10"/>
    <v-row class="flex-center-y">
      <div class="font-21-12">
        <p style="color: var(--red) !important"><a href="#" @click.prevent="scrollToNote" style="color: var(--red) !important;">利用上のご注意</a></p>
        <p style="color: var(--red) !important">・表示される金額等の結果は目安であり、実際の金額等を保証するものではありません。</p>
        <p style="color: var(--red) !important">・本シミュレーションは、中東情勢をはじめとする国際情勢の変化やそれに伴う影響を加味したものではありません。</p>
      </div>
    </v-row>
    <v-spacer class="spacing-h-32-24"/>
    <!-- 電力会社一覧：タブ（料金順、初年節約額順（特典込）、再生可能エネルギー100% (実質再エネ100を除く)） -->
    <v-row no-gutters>
      <v-col class="ma-0 pa-0">
        <v-tabs v-model="tab" slider-color="transparent" class="h-68-52">
          <v-tab class="max-w-285-124 h-68-52 border-radius-top mr-2 pa-0" value="cost" :class="{ 'active-tab': tab === 'cost', 'inactive-tab': tab !== 'cost' }">
              <span class="font-21-12 wrap">料金順</span>
          </v-tab>
          <!-- 初年節約額順（特典込）は一時的に非表示。依頼があった時に表示する -->
          <!-- <v-tab class="max-w-365-124 h-68-52 border-radius-top mr-2 pa-0" value="saving" :class="{ 'active-tab': tab === 'saving', 'inactive-tab': tab !== 'saving' }">
              <p class="font-21-12 wrap">
                初年節約額順<br v-if="smAndDown" />（特典込）
              </p>
          </v-tab> -->
          <v-tab class="max-w-365-124 h-68-52 border-radius-top pa-0" value="full" :class="{ 'active-tab': tab === 'full', 'inactive-tab': tab !== 'full' }" v-if="hasFullRenewable">
              <p class="font-21-12 wrap">
                再生可能エネルギー100%<br v-if="!smAndDown" />(実質再エネ100を除く)
              </p>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <!-- 電力会社一覧：全体枠 -->
    <v-row no-gutters class="flex-center" style="border:2px solid var(--blue)">
      <!-- 電力会社一覧：会社情報 -->
      <v-col class="max-w-1080-350 flex-column flex-center spacing-pa-inline-0-10">
        <v-spacer class="spacing-h-52-20"/>
        <v-card
            class="ma-0 pa-0 spacing-mb-52-20"
            :style="getBorderStyle(company)"
            v-for="(company, index) in filteredCompanies"
            :key="index"
            elevation="0"
            style="position: relative; overflow: visible; width: 100%; box-shadow: none;"
          >
          <!-- 再エネ１００マーク -->
          <img
            v-if="company.renewableEnergyType === '2' && !smAndDown"
            :src="require('@/assets/fv/renewable100.svg')"
            class="renewable-icon"
          />
          <v-card-text class="ma-0 spacing-pa-block-55-20 spacing-pa-inline-45-10">
            <!------------------------------------------------------------------------- 
                １：会社ロゴ、キャンペーン、会社名、プラン、申し込みページボタン
            -------------------------------------------------------------------------->
            <!-- PC版 -->
            <v-row v-if="!smAndDown" no-gutters>
              <!-- 会社ロゴ -->
              <v-col md="3" class="flex-start image-row" style="position: relative; z-index: 2;">
                  <div class="flex-center max-w-200-66 h-200-66 border overlap-image">
                    <v-img :src="require(`@/assets/${company.logoFile}`)"></v-img>
                  </div>
              </v-col>
              <!-- キャンペーン、会社名、プラン、申し込みページボタン、電気料金 -->
              <v-col md="9">
                <!-- キャンペーン -->
                <v-row class="spacing-pa-8-4 font-24-12 red text-left" style="border:2px solid var(--red)" no-gutters v-if="company.cityCampaignDisplayFlg === '1' && company.costDisplayFlg === '1'">
                  <!-- 特典あり：電気料金＋特典が現在のプランより安くなる -->
                  <span v-if="company.cityCampaignDetailDiscountAmount > 0 && company.afterTotalAnnualSavings > 0">
                    <span>世田谷区限定特典つきで、1年間で{{ (company.afterTotalAnnualSavings)?.toLocaleString() }}円</span>
                    <span v-if="company.cityCampaignDetailDiscountType != '値引き'">相当</span>
                    <span>オトクに！</span>
                    <span class="font-16-12">(※1)</span>
                  </span>
                  <!-- 特典あり：電気料金＋特典が現在のプランより高くなる -->
                  <span v-if="company.cityCampaignDetailDiscountAmount > 0 && company.afterTotalAnnualSavings < 0">
                    <span>{{ (company.cityCampaignDetailDiscountAmount)?.toLocaleString() }}円の世田谷区限定特典あり！</span>
                    <span class="font-16-12">(※1)</span>
                  </span>
                </v-row>
                <v-row class="spacing-pa-8-4 font-24-12 red text-left" style="border:2px solid var(--red)" no-gutters v-if="company.cityCampaignDisplayFlg === '0' && company.costDisplayFlg === '1' && company.afterTotalAnnualSavings > 0">
                  <!-- 電気料金＋企業特典が現在のプランより安くなる（キャンペーン終了後） -->
                  <span>
                    <span>各種特典込みで、1年間で{{ (company.afterTotalAnnualSavings)?.toLocaleString() }}円</span>
                    <span v-if="company.cityCampaignDetailDiscountType != '値引き'">相当</span>
                    <span>オトクに！</span>
                    <span class="font-16-12">(※1)</span>
                  </span>
                </v-row>
                <v-spacer class="spacing-h-24-10"/>
                <!-- 会社名、プラン、申し込みページボタン -->
                <v-row>
                    <!-- 会社名、プラン -->
                    <v-col md="7" cols="12">
                        <p class="font-18-10 ">{{ company.companyName }}</p>
                        <p class="font-30-18 ">{{ company.planName }}</p>
                        <!-- <p v-if="company.companyName === 'オクトパスエナジー'" class="font-24-12 red">※キャンペーン受付終了しました</p> -->
                      </v-col>
                    <!-- 申し込みページへボタン -->
                    <v-col md="5"  cols="12" class="flex-center-y flex-end-x flex-column">
                      <v-btn class="apply-btn flex-center max-w-280-280 h-70-50" elevation="0" @click="redirectToCompanyUrl(company.applyUrl)">
                        <div class="text-center spacing-mr-8-8">
                          <p class="font-18-14">詳細ページへ</p>
                          <p class="font-14-10">(各社の公式サイトへ遷移します)</p>
                        </div>
                        <v-icon right class="font-24-20">mdi-arrow-right-circle</v-icon>
                      </v-btn>
                      <v-spacer class="spacing-h-10-10"/>
                      <div class="font-14-10 weight-normal text-center">
                        <a href="#section-note"><u>利用上のご注意</u></a>をご確認ください
                      </div>
                    </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- スマホ版 -->
            <v-row v-else no-gutters>
              <v-col>
                <!-- キャンペーン -->
                <v-row class="spacing-pa-8-4 font-24-12 red text-left" style="border:2px solid var(--red)" no-gutters v-if="company.cityCampaignDisplayFlg === '1' && company.costDisplayFlg === '1'">
                  <!-- 特典あり：電気料金＋特典が現在のプランより安くなる -->
                  <span v-if="company.cityCampaignDetailDiscountAmount > 0 && company.afterTotalAnnualSavings > 0">
                    <span>世田谷区限定特典つきで、1年間で{{ (company.afterTotalAnnualSavings)?.toLocaleString() }}円</span>
                    <span v-if="company.cityCampaignDetailDiscountType != '値引き'">相当</span>
                    <span>オトクに！</span>
                    <span class="font-16-12">(※1)</span>
                  </span>
                  <!-- 特典あり：電気料金＋特典が現在のプランより高くなる -->
                  <span v-if="company.cityCampaignDetailDiscountAmount > 0 && company.afterTotalAnnualSavings < 0">
                    <span>{{ (company.cityCampaignDetailDiscountAmount)?.toLocaleString() }}円の世田谷区限定特典あり！</span>
                    <span class="font-16-12">(※1)</span>
                  </span>
                  <!-- 特典なし：非表示 -->
                  <span v-else>
                  </span>
                </v-row>
                <v-row class="spacing-pa-8-4 font-24-12 red text-left" style="border:2px solid var(--red)" no-gutters v-if="company.cityCampaignDisplayFlg === '0' && company.costDisplayFlg === '1' && company.afterTotalAnnualSavings > 0">
                  <!-- 電気料金＋企業特典が現在のプランより安くなる（キャンペーン終了後） -->
                  <span>
                    <span>各種特典込みで、1年間で{{ (company.afterTotalAnnualSavings)?.toLocaleString() }}円</span>
                    <span v-if="company.cityCampaignDetailDiscountType != '値引き'">相当</span>
                    <span>オトクに！</span>
                    <span class="font-16-12">(※1)</span>
                  </span>
                </v-row>
                <v-spacer class="spacing-h-10-10"/>
                <!-- 会社名、プラン、申し込みページボタン -->
                <v-row>
                  <!-- 会社ロゴ -->
                  <v-col cols="3" class="flex-start">
                    <!-- 再エネ１００マーク -->
                    <img
                      v-if="company.renewableEnergyType === '2'"
                      :src="require('@/assets/fv/renewable100.svg')"
                      class="renewable-icon"
                    />
                    <div class="flex-center max-w-200-66 h-200-66 border">
                        <v-img :src="require(`@/assets/${company.logoFile}`)"></v-img>
                      </div>
                  </v-col>
                  <!-- 会社名、プラン -->
                  <v-col cols="9" class="flex-start-x flex-center-y">
                    <div>
                      <p class="font-18-10 ">{{ company.companyName }}</p>
                      <p class="font-30-18 ">{{ company.planName }}</p>
                        <!-- <p v-if="company.companyName === 'オクトパスエナジー'" class="font-24-12 red">※キャンペーン受付終了しました</p> -->
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- 申し込みページへボタン -->
                  <v-spacer />
                  <v-col cols="9" class="flex-center-y flex-end-x flex-column">
                    <v-btn class="apply-btn flex-center w-256-220 max-w-256-220 h-70-50" elevation="0" @click="redirectToCompanyUrl(company.applyUrl)">
                      <div class="text-center spacing-mr-8-8">
                        <p class="font-18-14">詳細ページへ</p>
                        <p class="font-14-10">(各社の公式サイトへ遷移します)</p>
                      </div>
                      <v-icon right class="font-24-20">mdi-arrow-right-circle</v-icon>
                    </v-btn>
                    <v-spacer class="spacing-h-4-4"/>
                    <div class="font-14-10 weight-normal text-center">
                      <a href="#section-note"><u>利用上のご注意</u></a>をご確認ください
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-spacer class="spacing-h-20-20"/>
            <!------------------------------------------------------------------------- 
                ２：電気料金
            -------------------------------------------------------------------------->
            <div v-if="company.costDisplayFlg === '1'">
              <!-- TOP -->
              <v-row class="flex-center-y" style="z-index: 1; position: relative;">
                <v-col md="3" v-if="!smAndDown">
                </v-col>
                <!-- 計算結果：電気料金 -->
                <v-col md="8" cols="10" class="h-75-50 back-lightyellow flex-center-y">
                  <div class="spacing-ml-16-8 font-20-12 text-center nowrap">電気料金<br><span class="font-16-10">(月平均)</span></div>
                  <!-- 安い場合 -->
                  <div class="spacing-ml-16-8 flex-start-x flex-center-y" v-if="company.afterMonthlySavings > 0">
                    <div class="font-24-16 w-200-120" style="border:2px dashed red;" >
                      <div class="back-green spacing-pa-block-8-8 spacing-pl-4-4" style="width: 70%;">￥{{ company.afterMonthlyCost?.toLocaleString() }}</div>
                    </div>
                    <div class="spacing-ml-8-8 font-24-16 red">
                        ￥{{ company.afterMonthlySavings?.toLocaleString() }} <br v-if="smAndDown">お得！
                    </div>
                  </div>
                  <!-- 高い場合 -->
                  <div class="spacing-ml-16-8 flex-start-x flex-center-y" v-else>
                    <div class="back-green font-24-16 w-200-120">
                      <div class="back-green spacing-pa-block-8-8 spacing-pl-4-4" style="width: 70%;">￥{{ company.afterMonthlyCost?.toLocaleString() }}</div>
                    </div>
                  </div>
                </v-col>
                <!-- 詳細開閉ボタン -->
                <v-col md="1" cols="2" class="h-75-50 back-lightyellow flex-center">
                  <div class="details-btn" @click="togglecostDetail(index)">
                    <v-icon class="font-18-10">
                        {{ costDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
              <!-- 詳細 -->
              <v-expand-transition>
                <div v-show="costDetailMap.get(index)">
                  <!-- 料金詳細テーブル -->
                  <v-row>
                    <v-spacer />
                    <v-col md="9" cols="12">
                      <v-spacer class="spacing-h-24-24"/>
                      <v-simple-table class="font-15-10">
                        <thead>
                          <tr class="border">
                            <th class="cost-detail-item-header w-360-130">1年間のシミュレーション内訳</th>
                            <th class="cost-detail-current-header" style="width: 25%;">
                              <span v-if="searchType === 'simple'">一般的なプラン</span>
                              <span v-else>現在のプラン</span>
                              <span class="font-12-8">(※2)</span>
                            </th>
                            <th class="cost-detail-after-header" style="width: 25%;">切り替え後</th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- 現在のプランが東京電力の時にだけ内訳を表示（その他電力会社は計算できないため） -->
                          <tr v-if="company.currentDeailCostDisplayFlg === '1'">
                            <td class="cost-detail-item-data">電力使用量(年間、月平均)</td>
                            <td colspan="3" class="cost-detail-current-header">年間{{ annualUsage?.toLocaleString() }}kWh、月平均{{ Math.round(annualUsage/12)?.toLocaleString() }}kWh</td>
                          </tr>
                          <tr v-if="company.currentDeailCostDisplayFlg === '1'">
                            <td class="cost-detail-item-data">基本料金</td>
                            <td class="cost-detail-current-header">{{ currentBaseCost?.toLocaleString() }}円</td>
                            <td class="cost-detail-after-data">{{ company.afterBaseCost?.toLocaleString() }}円</td>
                          </tr>
                          <tr v-if="company.currentDeailCostDisplayFlg === '1'">
                            <td class="cost-detail-item-data">
                              <p>電力量料金</p>
                              <p class="font-14-9">(政府補助金や燃料調整費等を含む)</p>
                            </td>
                            <td class="cost-detail-current-data">{{ currentUsageCost?.toLocaleString() }}円</td>
                            <td class="cost-detail-after-data">{{ company.afterUsageCost?.toLocaleString() }}円</td>
                          </tr>
                          <tr v-if="company.currentDeailCostDisplayFlg === '1'">
                            <td class="cost-detail-item-data">再エネ賦課金</td>
                            <td class="cost-detail-current-data">{{ currentRenewableSurchargeCost?.toLocaleString() }}円</td>
                            <td class="cost-detail-after-data">{{ company.afterRenewableSurchargeCost?.toLocaleString() }}円</td>
                          </tr>
                          <tr class="" style="background-color: #f5f5f5;">
                            <td class="cost-detail-item-data">電気料金総額 (年間)</td>
                            <td class="cost-detail-current-data">{{ currentAnnualCost?.toLocaleString() }}円</td>
                            <td class="cost-detail-after-data red">{{ company.afterAnnualCost?.toLocaleString() }}円</td>
                          </tr>
                          <tr v-if="company.afterAnnualSavings > 0">
                            <td colspan="3" class="back-lightyellow spacing-pa-8-8 font-18-12 text-center" style="height: 64px;">
                              <div class="flex-center">
                                <div>
                                  <span>1年間の想定節約額(特典等除く)</span>
                                  <span class="font-16-12">(※3)</span>
                                </div>
                                <div>
                                  <span class="font-26-18 red spacing-pa-inline-8-8">{{ company.afterAnnualSavings?.toLocaleString() }}</span>
                                  <span>円</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                  <v-spacer class="spacing-h-24-24"/>
                  <!-- 補足 -->
                  <v-row>
                    <v-spacer/>
                    <v-col md="9" cols="12" class="font-16-12" v-if="searchType === 'simple'">
                      <div class="weight-normal">※1&emsp;一般的な電力プランと比較して、1年間の電気料金総額 (年間) の差と、世田谷区民限定特典および、各社の併用可能なキャンペーン (友人紹介等を除く) を合計した金額です。</div>
                      <div class="weight-normal">※2&emsp;"一般的なプラン"とは、東京電力エナジーパートナー社の従量電灯B 40Aを指します。</div>
                      <div class="weight-normal">※3&emsp;計算過程の一部で小数点以下を切り捨てており、内訳の合計と節約額の合計が一致しない場合があります。</div>
                    </v-col>
                    <v-col md="9" cols="12" class="font-16-12" v-else>
                      <div class="weight-normal">※1&emsp;現在の電力プランと比較して、1年間の電気料金総額 (年間) の差と、世田谷区民限定特典および、各社の併用可能なキャンペーン (友人紹介等を除く) を合計した金額です。</div>
                      <div class="weight-normal">※2&emsp;"現在のプラン"には、詳細診断にて入力した1年間の電気料金が表示されます。</div>
                      <div class="weight-normal">※3&emsp;計算過程の一部で小数点以下を切り捨てており、内訳の合計と節約額の合計が一致しない場合があります。</div>
                    </v-col>
                  </v-row>
                  <v-spacer class="spacing-h-40-24"/>
                  <!-- 申し込みページへボタン -->
                  <v-row class="flex-center">
                    <v-spacer/>
                    <v-col md="9" cols="12" class="flex-center flex-column">
                      <v-btn class="apply-btn flex-center max-w-280-220 h-70-50" elevation="0" @click="redirectToCompanyUrl(company.applyUrl)">
                        <div class="text-center spacing-mr-8-8">
                          <p class="font-18-14">詳細ページへ</p>
                          <p class="font-14-10">(各社の公式サイトへ遷移します)</p>
                        </div>
                        <v-icon right class="font-24-20">mdi-arrow-right-circle</v-icon>
                      </v-btn>
                      <v-spacer class="spacing-h-4-4"/>
                      <div class="font-14-10 weight-normal text-center">
                        <a href="#section-note"><u>利用上のご注意</u></a>をご確認ください
                      </div>
                    </v-col>
                  </v-row>
                  <v-spacer class="spacing-h-40-16"/>
                </div>
              </v-expand-transition>
              <v-spacer class="spacing-h-16-16"/>
            </div>
            <div v-else>
              <!-- TOP -->
              <v-row class="flex-center-y" style="z-index: 1; position: relative;">
                <v-col md="3" v-if="!smAndDown">
                </v-col>
                <!-- 計算結果：電気料金 -->
                <v-col md="9" cols="12" class="h-75-50 back-lightyellow flex-center-y">
                  <div class="spacing-ml-16-8 font-20-12 text-center nowrap">電気料金<br><span class="font-16-10">(月平均)</span></div>
                  <div class="spacing-ml-16-8 flex-start-x flex-center-y pt-1 pb-1 font-18-14">
                    市場連動型の料金プランのため、各社にご確認ください
                  </div>
                </v-col>
              </v-row>
              <v-spacer class="spacing-h-16-16"/>
            </div>
            <!------------------------------------------------------------------------- 
                ３：電力会社のこだわり
            -------------------------------------------------------------------------->
            <!-- TOP -->
            <!-- PC版 -->
            <v-row class="company-contents-area flex-center spacing-pl-24-0" style="background-color: #F7FAFF; border: 1px solid #E7EAFA; justify-content: start;" v-if="!smAndDown">
              <!-- ラベル -->
              <v-col md="3" class="company-contents-label flex-center back-blue">
                <div class="font-18-12">
                  <v-icon left class="spacing-mr-8-2">mdi-heart</v-icon>
                  <span>電力会社のこだわり</span>
                </div>
              </v-col>
              <!-- タイトル -->
              <v-col md="8" class="spacing-pl-16-16 font-20-14">
                {{ company.featureTopTitle.replace(/\\n/g, '\n') }}
              </v-col>
              <!-- 詳細開閉ボタン -->
              <v-col md="1" class="flex-center">
                  <div class="details-btn" @click="toggleFeatureDetails(index)">
                    <v-icon class="font-18-10">
                        {{ featureDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                  </div>
              </v-col>
            </v-row>
            <!-- スマホ版 -->
            <v-row class="company-contents-area spacing-pl-24-0" style="background-color: #F7FAFF; border: 1px solid #E7EAFA; justify-content: start;" v-else>
              <!-- ラベル -->
              <v-col cols="10" class="flex-start-y flex-column">
                <div class="back-blue pa-1" style="border-radius: 5px 0px 5px 0px;">
                  <div class="font-18-12" >
                    <v-icon left class="spacing-mr-8-2">mdi-heart</v-icon>
                    <span>電力会社のこだわり</span>
                  </div>
                </div>
                <div class="font-20-14 pa-2 wrap" style="width: 260px;">
                  {{ company.featureTopTitle.replace(/\\n/g, '\n') }}
                </div>
              </v-col>
              <!-- 詳細開閉ボタン -->
              <v-col cols="2" class="flex-center">
                <div class="details-btn" @click="toggleFeatureDetails(index)">
                  <v-icon class="font-18-10">
                      {{ featureDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                  </v-icon>
                </div>
              </v-col>
            </v-row>
            <!-- 詳細 -->
            <v-expand-transition v-show="featureDetailMap.get(index)">
              <div>
                <v-spacer class="spacing-h-22-10"/>
                <!-- 詳細タイトル -->
                <div class="font-18-14 blue feature-detail-title-text">{{ company.featureDetailTitle.replace(/\\n/g, '\n') }}</div>
                <v-spacer class="spacing-h-22-10"/>
                <!-- 詳細説明 -->
                <div class="font-16-12 feature-detail-text">{{ company.featureDetailDescription.replace(/\\n/g, '\n') }}</div>
                <v-spacer class="spacing-h-22-10"/>
              </div>
            </v-expand-transition>
            <!------------------------------------------------------------------------- 
                ４：世田谷区民限定特典
            -------------------------------------------------------------------------->
            <div v-if="company.cityCampaignDisplayFlg === '1'">
              <v-spacer class="spacing-h-16-16"/>
              <!-- TOP -->
              <!-- PC版 -->
              <v-row class="company-contents-area flex-center spacing-pl-24-0" style="background-color: #F0FFFD; border: 1px solid #E7EAFA;" v-if="!smAndDown">
                <!-- ラベル -->
                <v-col md="3" cols="12" class="company-contents-label flex-center back-green">
                  <div class="flex-center font-18-12">
                    <v-img class="img-gift spacing-mr-8-8" :src="require('@/assets/fv/gift.svg')" />
                    <span>世田谷区民限定特典</span>
                  </div>
                </v-col>
                <!-- タイトル -->
                <v-col md="8" cols="10" class="spacing-pl-16-16 font-20-14">
                  {{ company.cityCampaignTopTitle.replace(/\\n/g, '\n') }}
                </v-col>
                <!-- 詳細開閉ボタン -->
                <v-col md="1" cols="2" class="flex-center">
                    <div class="details-btn" @click="toggleCityCampaignDetails(index)">
                      <v-icon class="font-18-10">
                          {{ cityCampaignDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                      </v-icon>
                    </div>
                </v-col>
              </v-row>
              <!-- スマホ版 -->
              <v-row class="company-contents-area flex-center spacing-pl-24-0" style="background-color: #F0FFFD; border: 1px solid #E7EAFA;" v-else>
                <!-- ラベル -->
                <v-col cols="10" class="flex-start-y flex-column">
                  <div class="back-green pa-1" style="border-radius: 5px 0px 5px 0px;">
                    <div class="flex-center font-18-12">
                      <v-img class="img-gift" :src="require('@/assets/fv/gift.svg')" />
                      <span>世田谷区民限定特典</span>
                    </div>
                  </div>
                  <div class="font-20-14 pa-2 wrap" style="width: 260px;">
                    {{ company.cityCampaignTopTitle.replace(/\\n/g, '\n') }}
                  </div>
                </v-col>
                <!-- 詳細開閉ボタン -->
                <v-col cols="2" class="flex-center">
                  <div class="details-btn" @click="toggleCityCampaignDetails(index)">
                    <v-icon class="font-18-10">
                        {{ cityCampaignDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
              <!-- 詳細 -->
              <v-expand-transition v-show="cityCampaignDetailMap.get(index)">
                <div>
                  <v-spacer class="spacing-h-22-10"/>
                  <!-- 詳細タイトル -->
                  <p class="font-18-14 green">{{ company.cityCampaignDetailTitle.replace(/\\n/g, '\n') }}</p>
                  <v-spacer class="spacing-h-22-10"/>
                  <!-- 詳細（期間、概要、適用条件、受け取り方法） -->
                  <div class="font-16-10">
                    <v-row v-if="company.cityCampaignDetailStartDate != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">期間</v-col>
                      <!-- todo: テスト用日付 -->
                      <v-col md="11" cols="12" class="campaign-detail-text" >
                        <span v-if="company.cityCampaignDetailStartDate == '2026/5/1'">{{ '2026/6/1' }}～{{ company.cityCampaignDetailEndDate }}</span>
                        <span v-else-if="company.cityCampaignDetailStartDate == '2026/5/8'">{{ '2026/6/8' }}～{{ company.cityCampaignDetailEndDate }}</span>
                        <span v-else>{{ company.cityCampaignDetailStartDate }}～{{ company.cityCampaignDetailEndDate }}</span>
                      </v-col>
                    </v-row>
                    <v-spacer class="spacing-h-12-8"/>
                    <v-row v-if="company.cityCampaignDetailDescription != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">概要</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.cityCampaignDetailDescription.replace(/\\n/g, '\n') }}
                      </v-col>
                    </v-row>
                    <v-spacer class="spacing-h-56-12" v-if="company.cityCampaignDetailCondition != ''"/>
                    <v-row v-if="company.cityCampaignDetailCondition != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">適用条件</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.cityCampaignDetailCondition.replace(/\\n/g, '\n') }}
                      </v-col>
                    </v-row>
                    <v-spacer class="spacing-h-24-12" v-if="company.cityCampaignDetailCondition != ''"/>
                    <v-row v-if="company.cityCampaignDetailReceive != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">受け取り<br>方法</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.cityCampaignDetailReceive.replace(/\\n/g, '\n') }}
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-expand-transition>
            </div>
            <!------------------------------------------------------------------------- 
                ５：その他キャンペーン
            -------------------------------------------------------------------------->
            <div v-if="company.otherCampaignDisplayFlg === '1'">
              <v-spacer class="spacing-h-16-16"/>
              <!-- TOP -->
              <!-- PC版 -->
              <v-row class="company-contents-area flex-center spacing-pl-24-0" style="background-color: #F0FFFD; border: 1px solid #E7EAFA;" v-if="!smAndDown">
                <!-- ラベル -->
                <v-col md="3" cols="12" class="company-contents-label flex-center back-green">
                  <div class="flex-center font-18-12">
                    <v-img class="img-gift spacing-mr-8-8" :src="require('@/assets/fv/gift.svg')" />
                    <span>その他キャンペーン</span>
                  </div>
                </v-col>
                <!-- タイトル -->
                <v-col md="8" cols="10" class="spacing-pl-16-16 font-20-14">
                  {{ company.otherCampaignTopTitle }}
                </v-col>
                <!-- 詳細開閉ボタン -->
                <v-col md="1" cols="2" class="flex-center">
                    <div class="details-btn" @click="toggleOtherCampaignDetails(index)">
                      <v-icon class="font-18-10">
                          {{ otherCampaignDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                      </v-icon>
                    </div>
                </v-col>
              </v-row>
              <!-- スマホ版 -->
              <v-row class="company-contents-area flex-center spacing-pl-24-0" style="background-color: #F0FFFD; border: 1px solid #E7EAFA;" v-else>
                <!-- ラベル -->
                <v-col cols="10" class="flex-start-y flex-column">
                  <div class="back-green pa-1" style="border-radius: 5px 0px 5px 0px;">
                    <div class="flex-center font-18-12">
                      <v-img class="img-gift" :src="require('@/assets/fv/gift.svg')" />
                      <span>その他キャンペーン</span>
                    </div>
                  </div>
                  <div class="font-20-14 pa-2 wrap" style="width: 260px;">
                    {{ company.otherCampaignTopTitle.replace(/\\n/g, '\n') }}
                  </div>
                </v-col>
                <!-- 詳細開閉ボタン -->
                <v-col cols="2" class="flex-center">
                  <div class="details-btn" @click="toggleOtherCampaignDetails(index)">
                    <v-icon class="font-18-10">
                        {{ otherCampaignDetailMap.get(index) ? 'mdi-minus' : 'mdi-plus' }}
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
              <!-- 詳細 -->
              <v-expand-transition v-show="otherCampaignDetailMap.get(index)">
                <div>
                  <v-spacer class="spacing-h-22-10" v-if="company.otherCampaignDetailTitle != ''"/>
                  <!-- 詳細タイトル -->
                  <p class="font-18-14 green">{{ company.otherCampaignDetailTitle.replace(/\\n/g, '\n') }}</p>
                  <v-spacer class="spacing-h-22-10"/>
                  <!-- 詳細（期間、概要、適用条件、受け取り方法） -->
                  <div class="font-16-10">
                    <v-row v-if="company.otherCampaignDetailStartDate != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">期間</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.otherCampaignDetailStartDate }}～{{ company.otherCampaignDetailEndDate }}
                      </v-col>
                    </v-row>
                    <v-spacer class="spacing-h-12-8"/>
                    <v-row v-if="company.otherCampaignDetailDescription != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">概要</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.otherCampaignDetailDescription.replace(/\\n/g, '\n') }}
                      </v-col>
                    </v-row>
                    <v-spacer class="spacing-h-56-12" v-if="company.otherCampaignDetailCondition != ''"/>
                    <v-row v-if="company.otherCampaignDetailCondition != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">適用条件</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.otherCampaignDetailCondition.replace(/\\n/g, '\n') }}
                      </v-col>
                    </v-row>
                    <v-spacer class="spacing-h-24-12" v-if="company.otherCampaignDetailCondition != ''"/>
                    <v-row v-if="company.otherCampaignDetailReceive != ''">
                      <v-col md="1" cols="12" class="campaign-detail-text">受け取り<br>方法</v-col>
                      <v-col md="11" cols="12" class="campaign-detail-text">
                          {{ company.otherCampaignDetailReceive.replace(/\\n/g, '\n') }}
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-expand-transition>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-spacer class="spacing-h-80-32"/>
    <!-------------------------------------------------- 
        注釈・パンくずリスト
    -------------------------------------------------->
    <!-- 注釈 -->
    <v-row class="note-section font-21-12" no-gutters id="section-note">
      <div>
        <strong class="font-21-12">利用上のご注意</strong>
        <div>
          <div>1. 本サービスの位置づけと前提条件</div>
          <ul class="indented-list">
            <li>本シミュレーションは、UCHIKARAプロジェクトパートナー企業の小売電気事業者のうち、シミュレーションサイトへの参加を希望した企業のシミュレーションを行います。</li>
            <li>本シミュレーションは、ユーザーが入力した情報および一般的な前提条件に基づき、世田谷区が独自に設定した条件<a href="/conditions"><u>（試算条件）</u></a>のもと試算した参考情報です。</li>
            <li><strong><u>表示される金額等の結果は目安であり、実際の金額等を保証するものではありません。</u></strong></li>
            <li>実際の契約内容や電気料金とは異なる場合があります。<strong><u>ご契約の際は、必ず各電力会社の公式情報をご確認ください。</u></strong></li>
            <li>本シミュレーションは、中東情勢をはじめとする国際情勢の変化やそれに伴う影響を加味したものではありません。</li>
            <li>本サービスのご利用にあたっては、別途定める<a href="/terms"><u>利用規約</u></a>が適用されます。必ずご確認のうえご利用ください。</li>
          </ul>
        </div>
        <div>
          <div>2. 表示金額について</div>
          <ul class="indented-list">
            <li>表示される金額は、税込・月額換算です。金額は2026年9月末時点の小売電気事業者各社提供の情報に基づいています。各電力会社が予定している料金改定を反映できていない場合があります。</li>
            <li>「電気料金（月平均）」は、選択された世帯構成等条件に基づく、一般的な電気使用量を算出後、インプットしているデータに基づき、月別の電気料金を算出後、１年間分を平均して算出しています。</li>
            <li>詳細については、別途掲載している<a href="/conditions"><u>試算条件</u></a>のページをご確認ください。：</li>
            <li>インプットしているデータ</li>
            <li>  各社より提供された当該電力プランの</li>
            <li>
              <ul class="indented-list">
                <li>最新の基本料金</li>
                <li>最新の従量料金単価</li>
                <li>過去12ヵ月分の燃料費調整費、電源調達費（過去に政府補助金等が適用されている月は補助金適用後の数字を利用）</li>
              </ul>
            </li>
            <li>再生可能エネルギー発電促進賦課金単価は4.18円／kWhで計算しています。</li>
            <li>政府の電気料金支援に関しましては、2026年7月使用分（8月検針分）及び2026年9月使用分（10月検針分）から3.5円/kWh、2026年8月使用分（9月検針分）から4.5円/kWhの値引きが行われます。</li>
          </ul>
        </div>

        <div>
          <div>3. 割引・特典の扱いについて</div>
          <ul class="indented-list">
            <li>試算に反映される割引・特典は、以下の項目に明記されたもののみです。：
              <ul class="indented-list">
                <li>「世田谷区民限定特典」欄</li>
                <li>「その他キャンペーン」欄</li>
              </ul>
            </li>
            <li>それ以外の割引（例：セットサービス割引、口座振替割引、深夜機器割引など）は含まれていません。</li>
            <li>「その他キャンペーン」のうち、友人紹介など適用者が限定される特典は、節約額の合算対象外です。</li>
            <li>割引や特典の適用条件は電力会社ごとに異なります。最新の適用条件は必ず、契約前に各小売電気事業者の公式サイト等をご確認ください。</li>
          </ul>
        </div>

        <div>
          <div>4. 試算の基準・制約事項</div>
          <ul class="indented-list">
            <li>簡単診断を行う上では、年間節約額は、東京電力エナジーパートナー「従量電灯B・40A」との比較に基づいています。現在ご契約中のプランによっては、実際の節約額が異なる場合があります。</li>
            <li>シミュレーション結果では、小数点以下を切り捨てて表示しているため、内訳と合計金額に差が出る場合があります</li>
            <li>現在の契約条件や電力会社の受付状況により、お申し込みいただけない場合があります。</li>
          </ul>
        </div>

        <div>
          <div>5. CO₂削減量および情報の更新</div>
          <ul class="indented-list">
            <li>CO₂削減量の試算条件については、別途掲載している<a href="/conditions"><u>試算条件</u></a> のページをご確認ください。</li>
            <li>世田谷区民限定キャンペーンの最新情報については、各小売電気事業者の公式サイトをご確認ください。</li>
            <li>当サービスで提供する情報は、予告なく変更・更新される場合があります。</li>
          </ul>
        </div>
      </div>
    </v-row>

    <v-spacer class="spacing-h-60-40"/>
    <!-- パンくずリスト -->
    <v-row class="flex-start-x font-14-14" no-gutters>
      <v-col>
        <v-breadcrumbs class="ma-0 pa-0" divider="›">
          <v-breadcrumbs-item :to="{ name: 'TopPage' }">
            <u class="blue weight-normal">トップ</u>
          </v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>
            <span class="weight-normal">&emsp;>&emsp;でんき切替シミュレーション結果</span>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-spacer class="spacing-h-20-20"/>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import appInsights from '../plugins/appInsights'

const router = useRouter();
const { smAndDown } = useDisplay()

const scrollToNote = () => {
  // 固定ヘッダーの高さをここで調整
  const headerOffset = smAndDown ? 90 : 60; 
  const element = document.getElementById('section-note');

  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};

// データ定義
const result = ref(null)
const companies = ref([])
const transactionId = ref('');
const searchType = ref('');
const plasticBottle = ref(0);
const gasolene = ref(0);
const tree = ref(0);
const currentBaseCost = ref(0);
const currentUsageCost = ref(0);
const currentFuelAdjustmentCost = ref(0);
const currentPowerProcurementCost = ref(0);
const currentCapacityContributionCost = ref(0);
const currentRenewableSurchargeCost = ref(0);
const currentAnnualCost = ref(0);
const annualUsage = ref(0);
const tab = ref('cost'); // todo: キャンペーン期間中：saving、キャンペーン期間外：cost

function  getBorderStyle(company) {
  const isGreen = company.renewableEnergyType === '2';
  const sm = smAndDown;
  const borderWidth = isGreen
    ? (sm ? '6px' : '20x')
    : '2px';
  const borderColor = isGreen ? 'var(--green)' : 'lightgray';
  return {
    border: `${borderWidth} solid ${borderColor}`,
  };
}

// --- 会社ごとの開閉状態を管理 ---
// 料金詳細
const costDetailMap = ref(new Map());
function togglecostDetail(index) {
  const current = costDetailMap.value.get(index) || false;
  costDetailMap.value.set(index, !current);
}
// 電力会社のこだわり
const featureDetailMap = ref(new Map());
function toggleFeatureDetails(index) {
  const current = featureDetailMap.value.get(index) || false;
  featureDetailMap.value.set(index, !current);
}
// 世田谷区民限定特典
const cityCampaignDetailMap = ref(new Map());
function toggleCityCampaignDetails(index) {
  const current = cityCampaignDetailMap.value.get(index) || false;
  cityCampaignDetailMap.value.set(index, !current);
}
// その他キャンペーン
const otherCampaignDetailMap = ref(new Map());
function toggleOtherCampaignDetails(index) {
  const current = otherCampaignDetailMap.value.get(index) || false;
  otherCampaignDetailMap.value.set(index, !current);
}
// すべてのトグルを閉じる
function resetAllToggles() {
  costDetailMap.value = new Map();
  featureDetailMap.value = new Map();
  cityCampaignDetailMap.value = new Map();
  otherCampaignDetailMap.value = new Map();
}


// タブ選択されたら全てのトグルを閉じる
watch(tab, () => {
  resetAllToggles();
});

// 初期化処理（mounted相当）
onMounted(() => {
  try {
    const stored = localStorage.getItem('searchResult');
    if (!stored) throw new Error('検索結果が見つかりません');
    
    result.value = JSON.parse(stored);
    companies.value = result.value.companies || []
    transactionId.value = result.value.transactionId
    searchType.value = result.value.searchType
    plasticBottle.value = result.value.plasticBottle
    gasolene.value = result.value.gasolene
    tree.value = result.value.tree
    currentBaseCost.value = result.value.currentBaseCost
    currentUsageCost.value = result.value.currentUsageCost
    currentFuelAdjustmentCost.value = result.value.currentFuelAdjustmentCost
    currentPowerProcurementCost.value = result.value.currentPowerProcurementCost
    currentCapacityContributionCost.value = result.value.currentCapacityContributionCost
    currentRenewableSurchargeCost.value = result.value.currentRenewableSurchargeCost
    currentAnnualCost.value = result.value.currentAnnualCost
    annualUsage.value = result.value.annualUsage

    // ★ オプション：一度読み込んだら削除してもOK（再読み込み防止のため）
    // localStorage.removeItem('searchResult');
  } catch (e) {
    console.error('パースエラー:', e)
    router.push({ name: 'TopPage' });
  }
});


/************************************************************
 * 申し込みページへ遷移
 ************************************************************/
function redirectToCompanyUrl(url) {
  if (url) {
    appInsights.trackEvent({
      name: "CompanyRedirectClick",
      properties: {
        transactionId: transactionId.value,
        targetUrl: url,
        timestamp: new Date().toISOString()
      }
    })
    window.open(url, '_blank')
  } else {
    alert('URLが設定されていません')
  }
}

/************************************************************
 * タブ：料金順、初年節約額順（特典込）、再エネ100%
 ************************************************************/
const hasFullRenewable = computed(() =>
  companies.value.some(c => c.renewableEnergyType === '2')
)

 // 表示用のフィルタ＆ソート済みリスト
const filteredCompanies = computed(() => {
  if (tab.value === 'cost') {
    // 料金順
    return [...companies.value].sort((a, b) => Number(a.afterAnnualCost) - Number(b.afterAnnualCost))
  } else if (tab.value === 'saving') {
    // 初年節約額順（特典込）
    return [...companies.value].sort((a, b) => Number(b.afterTotalAnnualSavings) - Number(a.afterTotalAnnualSavings))
  } else if (tab.value === 'full') {
    // 再エネ100%、その中で料金順、初年節約額順（特典込）（複合ソート）
    return [...companies.value]
      .filter(c => c.renewableEnergyType === "2")
      .sort((a, b) => {
        if (Number(a.afterAnnualCost) !== Number(b.afterAnnualCost)) {
          return Number(a.afterAnnualCost) - Number(b.afterAnnualCost)
        } else {
          return Number(b.afterTotalAnnualSavings) - Number(a.afterTotalAnnualSavings)
        }
      })
  }
  return companies.value
})
// 電気代シミュレーション開始ボタン
function goToSearchWithDialog() {
    router.push({ name: 'Search', query: { showDialog: 'true' } });
}

</script>
